export const GET_MEDIA = "GET_MEDIA";
export const GET_MEDIUM_BY_ID = "GET_MEDIUM_BY_ID";
export const UPDATE_MEDIUM = "UPDATE_MEDIUM";
export const DELETE_MEDIUM = "DELETE_MEDIUM";
export const CREATE_MEDIUM = "CREATE_MEDIUM";
export const UPLOAD_MEDIA = "UPLOAD_MEDIA";
